export interface IValidation {
    unosCPRA: boolean,
    wasPreviouslySensitized: boolean,
    coldIschemicHours: boolean,
    transplantDate: boolean,
    transportCost: boolean,
    graftSurvival: boolean,
    graftFailureDate: boolean,
    graftFailureReason: boolean,
    graftFailureReasonOther: boolean,
    rejectionDueToNonCompliance: boolean,
    hadDelayedGraftFunction: boolean,
    deathDate: boolean,
    primaryCauseOfDeath: boolean,
    rejectionEpisodeDetail: boolean,
    donorUnosId: boolean,
    wasDesensitized: boolean,
    desensitizationType: boolean,
    primaryNonFunction: boolean,
    adminCreatinine: boolean,
    creatinine: { value: boolean, date: boolean }[]
}